export default __webpack_public_path__ + "static/media/favicon.7b7f2178.ico";